import React from "react";
import { useProductInfo } from "../../hooks/useProductInfo";
import { useCanManageListing } from "../../hooks/useCanManageListing";
import Queries from "../../../ProductDetails/childComponents/Queries";

interface QueriesSectionProps {
  title?: string;
}

const QueriesSection: React.FC<QueriesSectionProps> = ({ title }) => {
  const { queries, productId, isCurrentUserSeller, businessId, isSold } = useProductInfo();
  const canAnswerAsOwner = useCanManageListing(isCurrentUserSeller, businessId);

  return (
    <Queries
      queries={queries}
      productId={productId}
      // A sold listing takes no new inquiries — existing Q&A stays readable,
      // and the owner can still answer anything already asked.
      canAsk={!canAnswerAsOwner && !isSold}
      canAnswer={canAnswerAsOwner}
      title={title}
    />
  );
};

export default QueriesSection;
